import axios from 'axios'
import { baseURL } from './baseUrl'

axios.defaults.withCredentials = false

const axiosInstance = axios.create({
})

axiosInstance.interceptors.request.use(function (config) {
  // const constcookies = document.cookie.split(";")
  config.headers = {
    'Content-Type': 'multipart/form-data',
    // 'Authorization': cookies[cookies?.length - 1]
  }

  return config
})

axiosInstance.defaults.baseURL = baseURL

export default axiosInstance
